<div>

	<div class="dashboard-container upload">

		<upload-transcode-upload [autoName]="autoName" [autoPublish]="autoPublish" [embargo]="embargo"></upload-transcode-upload>

		<h2>{{ 'LATEST_MEDIA_CLIPS' | translate }}</h2>

		<bb-table-container>

			<bb-table-header>
				<bb-table-header-cell class="thumb"></bb-table-header-cell>
				<bb-table-header-cell class="icon"></bb-table-header-cell>
				<bb-table-header-cell [hideSorting]="true" property="id">{{ 'ID' | translate }}</bb-table-header-cell>
				<bb-table-header-cell [hideSorting]="true" property="title"></bb-table-header-cell>
				<bb-table-header-cell [hideSorting]="true" property="length">{{ 'LENGTH' | translate }}
				</bb-table-header-cell>
				<bb-table-header-cell [hideSorting]="true" property="createddate" class="date">{{ 'CREATED' | translate
					}}
				</bb-table-header-cell>
				<bb-table-header-cell [hideSorting]="true" property="status" class="icon"
					[ngClass]="{'status-and-stream-status': rowsContainLiveClips}">&nbsp;</bb-table-header-cell>
			</bb-table-header>

			<bb-table-row *ngFor="let row of rows" [row]="row">
				<bb-table-cell class="thumb">
					<bb-table-thumbnail [entity]="row.data"></bb-table-thumbnail>
				</bb-table-cell>
				<bb-table-cell><span style="white-space: no-break;"><span
							[innerHTML]="row.data | clipIcon"></span><strong
							[hidden]="row.data.usetype !== 'commercial'" style="padding: 3px; color: #f8b32a;"
							title="Creative">C</strong></span></bb-table-cell>
				<bb-table-cell class="length" property="id">{{ row.data.id }}</bb-table-cell>
				<bb-table-cell property="title" class="overflow">
					<span [hidden]="!row.data.title">{{ row.data.title }}</span>
					<span [hidden]="row.data.title" class="filename">{{ row.data.originalfilename }}</span>
				</bb-table-cell>
				<bb-table-cell class="length" property="length">{{ row.data.length | seconds }}</bb-table-cell>
				<bb-table-cell property="createddate" class="date" [titleValue]="row.data.createddate | bbDate">
					{{ row.data.createddate | bbDate:'relative' }}</bb-table-cell>
				<bb-table-cell property="status"
					*ngIf="row?.data?.sourceid?.startsWith('live_api_')"
					[ngClass]="{'status-and-stream-status': rowsContainLiveClips}"><span
						[innerHTML]="(row.data | statusIcon) + ' ' + (row.data | bbStreamStatusIcon | async)"
						class="stream-status-icon"></span></bb-table-cell>
				<bb-table-cell class="status" property="status"
					*ngIf="!row?.data?.sourceid?.startsWith('live_api_')"
					[ngClass]="{'status-and-stream-status': rowsContainLiveClips}"><span
						[innerHTML]="row.data | statusIcon"></span></bb-table-cell>
			</bb-table-row>

		</bb-table-container>

		<div class="no-results" *ngIf="rows && !rows.length">{{ 'NO_MEDIA_CLIPS_FOUND' | translate }}</div>

		<a class="button" [routerLink]="['/library/mediaclips']">
			<span>{{ 'VIEW_ALL_MEDIA_CLIPS' | translate }}</span>
		</a>

	</div>

</div>
